<num-searchbar
  [label]="'SHARED_FILTER.CONCEPT_FILTER.SEARCH_PLACEHOLDER' | translate"
  icon="search"
  (searchTextChange)="startElasticSearch($event)"
>
</num-searchbar>
